import { AxiosResponse } from "axios";
import { enqueueSnackbar } from "notistack";
import { useTranslation } from "react-i18next";
import { useMutation } from "react-query";
import { queryClient } from "src/shared/services/QeuryClient/reactQueryClient";
import { TMailBoxEmails } from "../types";
import { changeEmailsReadFlag } from "./gateway";

function useChangeEmailsRead() {
  const { t } = useTranslation();
  return useMutation({
    mutationFn: changeEmailsReadFlag,
    mutationKey: ["changeEmailsReadFlag"],
    onSuccess: (data, variables) => {
      if (variables.showNotification) {
        enqueueSnackbar(t("Επιτυχής Ενημέρωση"), { variant: "success" });
      }
      queryClient.invalidateQueries(["getMailBoxEmails"]);
    },
    onError: (e) => {
      console.log(e);
      enqueueSnackbar(t("Ανεπιτυχές Ενημέρωση"), { variant: "error" });
    },
    onMutate: async (args: {
      emails: { id: number; emailType: string }[];
      readFlag: boolean;
    }) => {
      // Cancel any outgoing refetches
      // (so they don't overwrite our optimistic update)
      await queryClient.cancelQueries({ queryKey: ["getMailBoxEmails"] });

      // Snapshot the previous value
      const previousValue = queryClient.getQueryData("getMailBoxEmails", {
        exact: false,
      });
      // Optimistically update to the new value
      queryClient.setQueriesData(
        { queryKey: "getMailBoxEmails", exact: false },
        (old: AxiosResponse<TMailBoxEmails>) => {
          const newData = old.data.data.map((item) => {
            if (args.emails.some((email) => email.id === item.id)) {
              return { ...item, readFlag: args.readFlag };
            } else {
              return item;
            }
          });
          return { ...old, data: { ...old.data, data: newData } };
        },
      );
      // Return a context object with the snapshotted value
      return { previousTodos: previousValue };
    },
  });
}

export default useChangeEmailsRead;
